import { BRAND_NAMES, FILTERS_TO_MAP, SLUGS_TO_IGNORE } from "./constants";

export const toggleFilterExpanded = (
  filterName,
  filterExpanded,
  setFiltersExpanded
) => {
  if (filterExpanded) {
    setFiltersExpanded((prev) => prev?.filter((item) => item !== filterName));
    return;
  }
  setFiltersExpanded((prev) => [...prev, filterName]);
};

export const toggleFiltersSelected = (
  filterSelected,
  selectedFilters,
  setSelectedFilters,
  option
) => {
  if (filterSelected) {
    let updatedFilters = selectedFilters?.filter((selectedFilter) => {
      selectedFilter?.slug !== option?.slug;
    });
    setSelectedFilters(updatedFilters);
  } else {
    setSelectedFilters([...selectedFilters, option]);
  }
};

export const stringChecker = (string, key) => {
  return !SLUGS_TO_IGNORE?.includes(string)
    ? ", " +
        (key === "maker"
          ? BRAND_NAMES?.[string]
          : FILTERS_TO_MAP?.[string] || string)
    : "";
};

export const selectedFiltersStringCreator = (selectedFilterValues) => {
  let selectedFilterValuesSliced = selectedFilterValues?.slice(0, 2);
  const selectedFiltersString =
    selectedFilterValuesSliced?.length > 0 &&
    `${stringChecker(
      selectedFilterValuesSliced?.[0]?.slug,
      selectedFilterValuesSliced?.[0]?.key
    )?.slice(1)}${stringChecker(
      selectedFilterValuesSliced?.[1]?.slug,
      selectedFilterValuesSliced?.[1]?.key
    )}${selectedFilterValues?.length > 2 ? " ..." : ""}`;
  return selectedFiltersString?.length > 30
    ? selectedFiltersString?.substring(0, 26) + "..."
    : selectedFiltersString;
};


export const modifyDynamicFilters = (filters) => {
  
  


}